// extracted by mini-css-extract-plugin
export default {"controls":"controls_controls__-hnA0","textareacontainer":"controls_textareacontainer__C6ahr","textarea":"controls_textarea__LZGZd","button":"controls_button__7jq0a"};